import gql from 'graphql-tag';
import * as types from '../DayPlanTypes';

const query = gql`
    query DailyPlan($today: Date!) {
        me {
            id
            recipeNotesForNextDay: dailyDietPlan(date: $today) {
                __typename
                ... on ${types.DAY_PLAN} {
                    id
                    recipeNotesForNextDay
                }
            }
            goal {
                reachedBecauseOfLoseWeight
                reachedBecauseOfPutOnWeight
                lostBecauseOfLoseWeight
                lostBecauseOfPutOnWeight
            }
            diet {
                dietId: id
                availableDays {
                    date
                    holiday {
                        identifier
                        name
                        description
                        icon
                    }
                    dayPlan {
                        dietSetId
                        diet {
                            id
                            name
                            phase {
                                identifier
                                name
                                colour
                            }
                        }
                    }
                }
            }
            isTimeToNagForCurrentMeasurement
            fastingStatistics {
                dietsCount
                currentDietLength
                currentDietProgress
            }
            intermittentFasting{
                activeCycle{
                    phase
                    phaseFinishPlannedTo
                }
            }
            flags {
                getOne(identifier: DIET_PLAN_INTRO_SEEN){
                    identifier
                }
            }
        }
    }
`;

export default query;
